import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { ordinalSuffixFormatter } from 'helper';
import { connect } from 'react-redux';
import * as actions from '../action';
import * as c from '../constant';

function StructuralMaterialsTab({
  historyInfo,
  getStructuralMaterialsLogs,
  dataInfo,
  isLoading,
  getFloorPlanLogs,
  floorArea
}) {

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getFloorPlanLogs(historyInfo.id);
  }, []);

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getStructuralMaterialsLogs(historyInfo.id, { isPaginate: 1 });
  }, []);

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getStructuralMaterialsLogs(historyInfo.id, { isPaginate: 1 });
  }, [historyInfo]);

  return (
    <div>
      <div className="p-3 row">
        <div className="col-8 header-modal">
          Roof Materials
        </div>
      </div>
      <div className="p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Materials</td>
                  </tr>
                </thead>
                <tbody>
                  {(dataInfo || []).filter(x => x.attributes.rptax_building_material_type_name === 'Roof').length === 0 ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    (dataInfo || []).filter(x => x.attributes.rptax_building_material_type_name === 'Roof').map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      <div className="p-3 row">
        <div className="col-8 header-modal">
          Flooring Materials
        </div>
      </div>
      <div className="p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <th width="350">Materials</th>
                    {(floorArea || []).map((s) => (
                      <th key={s.id} style={{ textAlign: 'center' }}>
                        {ordinalSuffixFormatter(s.attributes.floor)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(dataInfo || []).filter(x => x.attributes.rptax_building_material_type_name === 'Flooring').length === 0 ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    dataInfo.filter(x => x.attributes.rptax_building_material_type_name === 'Flooring').map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                        {(floorArea || []).map((s) => (
                          <td style={{ textAlign: 'center' }} key={s.id}>
                            <input
                              readOnly
                              type="checkbox"
                              checked={item.attributes.floor.includes(s.attributes.floor)}
                              value={s}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
      <div className="p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Building Material</td>
                    {(floorArea || []).map((s) => (
                      <th key={s.id} style={{ textAlign: 'center' }}>
                        {ordinalSuffixFormatter(s.attributes.floor)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {_.isEmpty((dataInfo || []).filter(x => x.attributes.rptax_building_material_type_name === 'Walls & Partitions')) ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    (dataInfo || []).filter(x => x.attributes.rptax_building_material_type_name === 'Walls & Partitions').map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.rptax_building_material_name') || ''}</td>
                        {(floorArea || []).map((s) => (
                          <td style={{ textAlign: 'center' }} key={s.id}>
                            <input
                              readOnly
                              type="checkbox"
                              checked={item.attributes.floor.includes(s.attributes.floor)}
                              value={s}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

StructuralMaterialsTab.propTypes = {
  historyInfo: PropTypes.instanceOf(Object),
  getStructuralMaterialsLogs: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Array).isRequired,
  getFloorPlanLogs: PropTypes.instanceOf(Function).isRequired,
  floorArea: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

StructuralMaterialsTab.defaultProps = {
  historyInfo: {}
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_STRUCTURAL_MATERIAL_LOGS) > -1,
  dataInfo: _.get(api, `${c.GET_STRUCTURAL_MATERIAL_LOGS}.list`) || [],
  floorArea: _.get(api, `${c.GET_FLOOR_PLAN_LOGS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(StructuralMaterialsTab);